import { Show, type JSX } from 'solid-js'
import Css from './filters.module.scss'
import { TextFilter } from './text-filter'

/**
 * Um campo de formulario: o rotulo, o campo e o erro DELE embaixo.
 *
 * Irmao do `TextFilter`, e nao o mesmo: um filtro nunca esta errado - ele apenas
 * acha ou nao acha -, e um campo de formulario passa a vida sendo recusado. O erro
 * fica colado no campo de proposito: a mensagem unica no rodape do dialogo obriga
 * quem digitou a adivinhar qual dos cinco campos o servidor nao aceitou.
 */
export function FormField(props: {
    label: string
    value: string
    placeholder?: string
    error?: string
    /** Ocupa a linha inteira numa grade de duas colunas. */
    wide?: boolean
    onChange: (value: string) => void
}): JSX.Element {
    return (
        <div classList={{ [Css.wide]: props.wide }}>
            <TextFilter
                label={props.label}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.onChange}
            />
            <Show when={props.error}>{(message) => <p class={Css.error}>{message()}</p>}</Show>
        </div>
    )
}
